import { render, staticRenderFns } from "./EmailVetorial.vue?vue&type=template&id=736f1a13&scoped=true"
import script from "./EmailVetorial.vue?vue&type=script&lang=js"
export * from "./EmailVetorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736f1a13",
  null
  
)

export default component.exports